import { useFormikContext } from 'formik';
import { IUser } from '../../types';

export function useUserFormContext() {
    return useFormikContext<IUser>()
}